import { _ } from "~/i18n";
import createSDSIcon from "~/ui/icon";
import { ICON_ADD_BUSINESS_24, ICON_ADD_PLACE_24, ICON_DISTANCEMETER_24, ICON_DOWNLOAD_IMAGE_24, ICON_EXCLAMATION_CIRCLE_24, ICON_EXPAND_MORE_20, ICON_FEEDBACK_24, ICON_IMPORT_24, ICON_MAP_EDIT_24, ICON_PRINT_24, ICON_USERMARKS_24 } from "~/ui/icons";
import PopOver, { IPopOverProps } from "~/ui/popover";
import { createPremiumIcon, node, text } from "~/util/dom";
import { downloadAsImage } from "~/util/image";
import GPXImport from "~/gpx/import";
import Scene from "~/scene";
import { onAddBusiness, onAddPlace, onMapError, onMapNote, onPremium, onSomethingWrong } from "~/util/feedback";
import { EMPTY_SYMBOL_24 } from "@sznds/icons";
import { CONFIG } from "~/config";
import { ADD_FIRM_LINK } from "~/report/const";
import { MYMAPS_SHARE } from "~/ui/sds-compatible-icons";
import { share } from "~/util/userweb";

export default class ToolsMenu {
	#popOver: PopOver;

	#content: HTMLMapyMapmenuElement;

	constructor(props: Pick<IPopOverProps, "anchor" | "onClose" | "onOpen" | "position" | "activator">) {
		this.#content = node("mapy-mapmenu", { className: "toolsMenu__mapy-mapmenu" });
		const { anchor, onClose, onOpen, position, activator } = props;

		// sdileni
		const shareItem = node("mapy-mapmenu-item");

		shareItem.append(createSDSIcon({ symbol: MYMAPS_SHARE, className: "toolsMenu__shareIcon" }), text(_("share")));
		shareItem.addEventListener("click", () => {
			this.close();
			share();
		}, false);

		// tisk
		const printItem = node("mapy-mapmenu-item");

		printItem.append(createSDSIcon({ symbol: ICON_PRINT_24 }), text(_("report.menu.print")));
		printItem.addEventListener("click", () => {
			this.close();
			Mapy.getComponent("history").save(true);
			Mapy.getComponent("print").print();
		}, false);

		// stahnout jako obrazek
		const downloadItem = node("mapy-mapmenu-item");

		downloadItem.append(createSDSIcon({ symbol: ICON_DOWNLOAD_IMAGE_24 }), text(_("darthControl.contentPicture")));
		downloadItem.addEventListener("click", () => {
			this.close();
			downloadAsImage();
		}, false);

		// import GPX
		const importItem = node("mapy-mapmenu-item");

		importItem.append(createSDSIcon({ symbol: ICON_IMPORT_24 }), text(_("darthControl.importXML")));
		importItem.addEventListener("click", () => {
			this.close();
			// FIXME: tady se mozna rozbije stav m3d ve store? treba overit
			if (Scene.isMapActive()) {
				GPXImport.open({
					detectFolder: true,
					logType: "tools",
				});
			} else {
				Scene.setActive("map").then(() => {
					GPXImport.open({
						detectFolder: true,
						logType: "tools",
					});
				}, () => {});
			}
		}, false);

		// vlastni body
		const usermarksItem = node("mapy-mapmenu-item");

		usermarksItem.append(createSDSIcon({ symbol: ICON_USERMARKS_24 }), text(_("toolsmenu.usermarks")));
		usermarksItem.addEventListener("click", () => {
			this.close();
			Mapy.getComponent("userMarks").activate();
			Mapy.getComponent("history").save();
		}, false);

		// mereni vzdalenosti
		const distancemeterItem = node("mapy-mapmenu-item");

		distancemeterItem.append(createSDSIcon({ symbol: ICON_DISTANCEMETER_24 }), text(_("darthControl.distanceMeter")));
		distancemeterItem.addEventListener("click", () => {
			this.close();
			Mapy.getComponent("distanceMeter").activate().setState({ interactive: true });
			Mapy.getComponent("history").save();
		}, false);

		// problemy s premiem
		const premiumReport = [];
		const premiumReportItem = node("mapy-mapmenu-item");

		premiumReportItem.append(createPremiumIcon(), text(_("report.premiumMenuItem")));
		premiumReportItem.addEventListener("click", () => {
			this.close();
			onPremium();
		}, false);
		premiumReport.push(premiumReportItem);

		// pridat misto
		const addPlaceItem = node("mapy-mapmenu-item");
		let addBusinessItems: Array<HTMLElement> = [];

		addPlaceItem.append(createSDSIcon({ symbol: ICON_ADD_PLACE_24 }), text(_("report.addPlace")));
		addPlaceItem.addEventListener("click", () => {
			this.close();
			onAddPlace();
		}, false);

		if (CONFIG.defaultLang === "cs") {
			// firma v Cesku
			const addBusinessCzechItem = node("a", { className: "mapy-mapmenu-item hidden", href: ADD_FIRM_LINK, target: "_blank", rel: "noopener", tabIndex: 0 });

			addBusinessCzechItem.append(createSDSIcon({ symbol: EMPTY_SYMBOL_24 }), text(_("report.inCzechia")));
			addBusinessCzechItem.addEventListener("click", () => {
				this.close();
				onAddBusiness(true);
			}, false);

			// firma v zahranici
			const addBusinessForeignItem = node("mapy-mapmenu-item", { className: "hidden" });

			addBusinessForeignItem.append(createSDSIcon({ symbol: EMPTY_SYMBOL_24 }), text(_("report.outsideCzechia")));
			addBusinessForeignItem.addEventListener("click", () => {
				this.close();
				onAddBusiness();
			}, false);

			// pridat firmu
			const addBusinessItem = node("mapy-mapmenu-item", { className: "mapy-mapmenu-item-submenu" });

			addBusinessItem.append(createSDSIcon({ symbol: ICON_ADD_BUSINESS_24 }), node("span", { className: "mapy-mapmenu-item__text", innerText: _("report.addFirm") }), createSDSIcon({ symbol: ICON_EXPAND_MORE_20 }));
			addBusinessItem.addEventListener("click", () => {
				if (addBusinessCzechItem.classList.contains("hidden")) {
					addBusinessItem.classList.add("mapy-mapmenu-item-submenu__visible");
					addBusinessCzechItem.classList.remove("hidden");
					addBusinessForeignItem.classList.remove("hidden");
				} else {
					addBusinessItem.classList.remove("mapy-mapmenu-item-submenu__visible");
					addBusinessCzechItem.classList.add("hidden");
					addBusinessForeignItem.classList.add("hidden");
				}
			}, false);

			addBusinessItems = [
				addBusinessItem,
				addBusinessCzechItem,
				addBusinessForeignItem,
			];
		} else {
			// pridat firmu
			const addBusinessItem = node("mapy-mapmenu-item");

			addBusinessItem.append(createSDSIcon({ symbol: ICON_ADD_BUSINESS_24 }), text(_("report.addFirm")));
			addBusinessItem.addEventListener("click", () => {
				this.close();
				onAddBusiness();
			}, false);

			addBusinessItems = [
				addBusinessItem,
			];
		}

		// chyba v mape
		const errorItem = node("mapy-mapmenu-item");

		errorItem.append(createSDSIcon({ symbol: ICON_MAP_EDIT_24 }), text(_("report.mapError")));
		errorItem.addEventListener("click", () => {
			this.close();
			onMapError();
		}, false);

		// neco nefunguje
		const wrongItem = node("mapy-mapmenu-item");

		wrongItem.append(createSDSIcon({ symbol: ICON_EXCLAMATION_CIRCLE_24 }), text(_("report.somethingWentWrong")));
		wrongItem.addEventListener("click", () => {
			this.close();
			onSomethingWrong();
		}, false);

		// pripominka k Mapy.cz
		const feedbackItem = node("mapy-mapmenu-item");

		feedbackItem.append(createSDSIcon({ symbol: ICON_FEEDBACK_24 }), text(_("report.mapyczNote")));
		feedbackItem.addEventListener("click", () => {
			this.close();
			onMapNote();
		}, false);

		// ve 3D se nektere polozky nezobrazi
		const isM3dActive = Scene.isM3dActive();

		// slozime menu dohromady
		this.#content.append(
			node("mapy-mapmenu-title", { innerHTML: _("darthControl.tools") }),
			...Mapy.getComponent("gpx").isActive() ? [] : [shareItem],
			printItem,
			...Mapy.Util.downloadSupported ? [downloadItem] : [],
			..."FileReader" in window ? [importItem] : [],
			...isM3dActive
				? []
				: [
					usermarksItem,
					distancemeterItem,
				],
			node("mapy-mapmenu-divider"),
			node("mapy-mapmenu-title", { innerHTML: _("toolsmenu.editMap") }),
			...premiumReport,
			addPlaceItem,
			...addBusinessItems,
			errorItem,
			wrongItem,
			feedbackItem,
		);

		this.#popOver = new PopOver({
			content: this.#content,
			anchor,
			onClose,
			onOpen,
			offset: 8,
			position,
			activator,
			className: "toolsMenu__popOver",
		});
	}

	destroy() {
		this.#popOver.destroy();
		this.#popOver = null;
	}

	get element() {
		return this.#content;
	}

	open() {
		this.#popOver.open();
	}

	close() {
		this.#popOver.close();
	}
}
